module.exports = __webpack_public_path__ + "static/media/Promo.bf39a4ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-inalambrico/Promo.svg
// module id = 204
// module chunks = 0